<app-navbar complement="false" customTitle="false">
  <div class="container-fluid bg-light mh-100">
    <div class="col-12 d-flex justify-content-center">
      <div class="row mt-5">
        <h2 class="title-page">Selecione seu perfil</h2>
      </div>
    </div>
    <div class="row d-flex justify-content-center col-12 ml-2">
      <app-selecao-tipo-usuario
        [customTitle]="false"
        *ngIf="!hasForm"
        (tipoSelecionado)="onTipoSelecionado($event)"
        [deveExibirAlertaPF]="false">
      </app-selecao-tipo-usuario>

      <app-dados-credor
      class="col-12 box-form"
        *ngIf="hasForm && isEmpresa"
        [formEmpresa]="formEmpresa"
        (adicionarEmpresa)="adicionarEmpresa()"
        (removerEmpresa)="removerEmpresa($event)"
        (voltar)="onVoltar()"
        [mostrarBotaoVoltar]="true"
        (efetuarCadastro)="cadastrarEmpresas()"
        [titulo]="'Dados do Credor Pessoa Jurídica'">
      </app-dados-credor>

      <app-formulario-entidade
      class="col-12 ml-3 box-form "
        *ngIf="hasForm && isEntidade"
        [formEntity]="formEntity"
        [tableDdi]="tableDdi"
        (efetuarCadastro)="cadastrarEntidade()"
        [mostrarBotaoVoltar]="true"
        (voltar)="onVoltar()"
        [titulo]="'Dados da Entidade'"
        >
      </app-formulario-entidade>
    </div>
  </div>
</app-navbar>
<app-footer></app-footer>
